import { createContext, useContext, useLayoutEffect } from 'react';

/** Wide is the layout default. A page passes `narrow` to keep the header and column together. */
export type LscContentColumn = 'wide' | 'narrow';

export const LscContentColumnSetterContext = createContext<(column: LscContentColumn) => void>(
  () => {}
);

export function useLscContentColumn(column: LscContentColumn): void {
  const setColumn = useContext(LscContentColumnSetterContext);
  useLayoutEffect(() => {
    setColumn(column);
    return () => setColumn('wide');
  }, [setColumn, column]);
}
